import { apiPost } from "../../../../../../Service/Api/ApiMethod";

export const uploadFile = (file, onProgress) => {
  const controller = new AbortController();
  const formData = new FormData();
  formData.append("file", file);

  const uploadPromise = apiPost("_uploadFloorPlan", formData,null, {
    headers: { "Content-Type": file.type },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percentCompleted);
    },
    signal: controller.signal,
  });

  return { promise: uploadPromise, cancel: () => controller.abort() };
};
